import type { ReactNode } from 'react';
import { WeatherWidget } from './WeatherWidget';
import { RadarWidget } from './RadarWidget';
import { TodosWidget } from './TodosWidget';
import { StickyNotesWidget } from './StickyNotesWidget';
import { TrafficWidget } from './TrafficWidget';
import { MessagesWidget } from './MessagesWidget';
import { UpcomingWidget } from './UpcomingWidget';

/**
 * Phone-first stacked widgets under the calendar.
 * Order: weather → radar → todos → sticky notes (+ traffic / messages / upcoming).
 */
export function MobileStack() {
  const sections: Array<{ key: string; title: string; node: ReactNode }> = [
      { key: 'weather', title: 'Weather', node: <WeatherWidget /> },
      { key: 'radar', title: 'Live radar', node: <RadarWidget /> },
      { key: 'todos', title: 'To-do / chores', node: <TodosWidget /> },
      { key: 'stickies', title: 'Sticky notes', node: <StickyNotesWidget /> },
      { key: 'traffic', title: 'Traffic reports', node: <TrafficWidget /> },
      { key: 'upcoming', title: 'Upcoming', node: <UpcomingWidget /> },
      { key: 'messages', title: 'Messages', node: <MessagesWidget /> },
    ];

  return (
    <div className="flex flex-col gap-3 pb-8">
      {sections.map((s) => (
        <section
          key={s.key}
          className="min-h-[12rem] rounded-2xl border border-slate-700/70 bg-slate-900/90 p-3 shadow-lg light:border-slate-200 light:bg-white"
        >
          {s.node}
        </section>
      ))}
    </div>
  );
}
